import Vue from 'vue'
import Router from 'vue-router'
import moment from "moment";
Vue.use(Router)

import Home from '@/components/home.vue';
import NotFound from '@/components/404.vue';

const routes = [
  {
    path: '/',
    component: Home,
  },
  //404
  {
    path: '/404',
    component: NotFound,
  },
  {
    path: '*',
    redirect: '/404'
  },
]

const router = new Router({
  mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  if (
    // window.location.host === "localhost:8080" ||
    window.location.host === "ssy-app.com" ||
    window.location.host === "www.ssy-app.com"
  ) {
    let _t = moment(Date.now()).format("YYYYMMDDHHmm");
    if (window.innerWidth >= 1024) {
      return window.location.replace(
        "/ssy-index.html" +
        (window.location.search
          ? window.location.search + "&_t=" + _t
          : "?_t=" + _t)
      );
    } else {
      return window.location.replace(
        "/m-ssy-index.html" +
        (window.location.search
          ? window.location.search + "&_t=" + _t
          : "?_t=" + _t)
      );
    }
  }
  next();
});
window._doRouterPush = (path) => router.push({ path });
window._doRouterReplace = (path) => router.replace({ path });

export default router;
